export const nursingSpecializations = [
    { id: 1, name: 'General Nursing' },
    { id: 2, name: 'Critical Care Nursing' },
    { id: 3, name: 'ICU Nursing' },
    { id: 4, name: 'Emergency Nursing' },
    { id: 5, name: 'Pediatric Nursing' },
    { id: 6, name: 'Neonatal Nursing (NICU)' },
    { id: 7, name: 'Obstetric Nursing' },
    { id: 8, name: 'Labor & Delivery Nursing' },
    { id: 9, name: 'Postpartum Nursing' },
    { id: 10, name: 'Surgical Nursing' },
    { id: 11, name: 'Operating Room Nursing' },
    { id: 12, name: 'Post-Anesthesia Care Nursing' },
    { id: 13, name: 'Cardiac Nursing' },
    { id: 14, name: 'Oncology Nursing' },
    { id: 15, name: 'Dialysis Nursing' },
    { id: 16, name: 'Nephrology Nursing' },
    { id: 17, name: 'Orthopedic Nursing' },
    { id: 18, name: 'Neurology Nursing' },
    { id: 19, name: 'Psychiatric Nursing' },
    { id: 20, name: 'Mental Health Nursing' },
    { id: 21, name: 'Geriatric Nursing' },
    { id: 22, name: 'Community Health Nursing' },
    { id: 23, name: 'Public Health Nursing' },
    { id: 24, name: 'Home Health Nursing' },
    { id: 25, name: 'Hospice & Palliative Care Nursing' },
    { id: 26, name: 'Wound Care Nursing' },
    { id: 27, name: 'Infection Control Nursing' },
    { id: 28, name: 'Diabetes Nursing' },
    { id: 29, name: 'Respiratory Nursing' },
    { id: 30, name: 'Gastroenterology Nursing' },
    { id: 31, name: 'Dermatology Nursing' },
    { id: 32, name: 'Ophthalmology Nursing' },
    { id: 33, name: 'ENT Nursing' },
    { id: 34, name: 'Urology Nursing' },
    { id: 35, name: 'Burn Care Nursing' },
    { id: 36, name: 'Trauma Nursing' },
    { id: 37, name: 'Transplant Nursing' },
    { id: 38, name: 'Rehabilitation Nursing' },
    { id: 39, name: 'Pain Management Nursing' },
    { id: 40, name: 'Ambulatory Care Nursing' },
    { id: 41, name: 'School Nursing' },
    { id: 42, name: 'Occupational Health Nursing' },
    { id: 43, name: 'Flight Nursing' },
    { id: 44, name: 'Forensic Nursing' },
    { id: 45, name: 'Radiology Nursing' },
    { id: 46, name: 'Infusion Nursing' },
    { id: 47, name: 'Nursing Administration' },
    { id: 48, name: 'Nurse Educator' },
    { id: 49, name: 'Clinical Nurse Specialist' },
    { id: 50, name: 'Nurse Practitioner' }
];
